module.exports = __webpack_public_path__ + "static/media/TAKHZYRO_Global_Logo_Color_RGB.c8dfafa7.png";